// extracted by mini-css-extract-plugin
export var dropdownButton = "_1p-0";
export var fullWidthDropdownButton = "_1p-1";
export var icon = "_1p-3";
export var iconPlaceholder = "_1p-2";
export var menuItemRow = "_1p-5";
export var shortcutContainer = "_1p-4";